const Menu = [
  {
    name: "Send Notifications",
    url: "/notifications",
    imageClass: "fa-solid fa-bell faicon",
  },
  // {
  //   name: "Category",
  //   url: "/category",
  //   imageClass: "fa-solid fa-table-cells-large faicon",
  // },
  // {
  //   name: "Locations",
  //   url: "/locations",
  //   imageClass: "fa-solid fa-location-dot faicon",
  // },
  // {
  //   name: "Offers",
  //   url: "/offers",
  //   imageClass: "fa-solid fa-tags faicon",
  // },
  {
    name: "Support",
    url: "/support",
    imageClass: "fa-solid fa-envelope-open-text faicon",
  },
  {
    name: "Cards",
    url: "/cards",
    imageClass: "fa-solid fa-address-card faicon",
  },
  // {
  //   name: "Benefits",
  //   url: "/benefits",
  //   imageClass: "fa-solid fa-check faicon",
  // },
  {
    name: "News",
    url: "/news",
    imageClass: "fa-solid fa-newspaper faicon",
  },
  {
    name: "Charging Points",
    url: "/ChargingPoints",
    imageClass: "fa-solid fa-charging-station faicon",
  },
  {
    name: "Users",
    url: "/Users",
    imageClass: "fa-solid fa-user faicon",
  },
  {
    name: "Charging History",
    url: "/ChargingHistory",
    imageClass: "fa-solid fa-clock-rotate-left faicon",
  },
  {
    name: "Charging",
    url: "/addCharging",
    imageClass: "fa-solid fa-bolt faicon",
  },
  {
    name: "Generate Invoice",
    url: "/generateInvoice",
    imageClass: "fa-solid fa-file-invoice faicon",
  },
  {
    name: "Faqs",
    url: "/faqs",
    imageClass: "fa-solid fa-question faicon",
  },
  // {
  //   name: "Card Requests",
  //   url: "/requestedcards",
  //   imageClass: "fa-solid fa-id-card faicon",
  // },
];

export default Menu;
